// Display text for the onboarding wizard and the dashboard checklist. The
// keys come from @prakash-software/shared's onboarding catalog.

import type {
  ChecklistItemKey,
  OnboardingChannel,
  OnboardingGoal,
  OnboardingPlatform,
  OnboardingStep,
  OnboardingTeamSize,
} from '@prakash-software/shared';

export const STEP_LABEL: Record<OnboardingStep, string> = {
  profile: 'Your business',
  goal: 'Main goal',
  team_size: 'Team size',
  platform: 'Website platform',
  channels: 'Channels',
  widget: 'Chat widget',
  install: 'Install',
};

export const CHECKLIST_LABEL: Record<ChecklistItemKey, string> = {
  verify_email: 'Confirm your email',
  profile: 'Add your business details',
  goal: 'Choose your main goal',
  team_size: 'Tell us your team size',
  platform: 'Pick your website platform',
  channels: 'Choose your channels',
  widget: 'Customize your chat widget',
  install: 'Install the widget on your website',
  test_message: 'Send yourself a test message',
  first_conversation: 'Receive your first real visitor message',
};

export const GOAL_LABEL: Record<OnboardingGoal, string> = {
  support: 'Answer customer questions',
  leads: 'Capture leads',
  sales: 'Help visitors buy',
  automation: 'Automate replies with AI',
  explore: 'Just exploring',
};

export const TEAM_SIZE_LABEL: Record<OnboardingTeamSize, string> = {
  '1-5': 'Just me, or up to 5',
  '6-10': '6–10',
  '11-25': '11–25',
  '26+': '26 or more',
};

export const PLATFORM_LABEL: Record<OnboardingPlatform, string> = {
  shopify: 'Shopify',
  wordpress: 'WordPress',
  'wix-squarespace': 'Wix or Squarespace',
  custom: 'Custom-built site',
  none: "I don't have a website yet",
  other: 'Something else',
};

export const CHANNEL_LABEL: Record<OnboardingChannel, string> = {
  web: 'Website chat',
  whatsapp: 'WhatsApp',
  instagram: 'Instagram',
  messenger: 'Facebook Messenger',
  email: 'Email',
};

/** Where to paste the snippet, per platform. Every option is the same script
 *  tag — Openline has no platform apps — so this only says where it goes. */
export const INSTALL_HINT: Record<OnboardingPlatform, string> = {
  shopify: 'In Shopify admin, open Online Store → Themes → Edit code, open theme.liquid, and paste it just before </body>.',
  wordpress: 'Use a header-and-footer code plugin (for example WPCode) and paste it into the footer section, or add it to your theme just before </body>.',
  'wix-squarespace': 'Wix: Settings → Custom code → Add custom code, placed in Body – end. Squarespace: Settings → Advanced → Code injection → Footer.',
  custom: 'Paste it into your site template just before the closing </body> tag, on every page that should show the chat.',
  none: 'When your website is ready, paste it just before the closing </body> tag.',
  other: 'Add it to your site so it loads on every page — usually just before the closing </body> tag.',
};
